import { useActivePartnerEntity } from '@app/hooks/useActivePartnerEntity';
import { FC, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppSelector } from '@app/hooks/useReduxToolkit';
import { UserCapabilities } from '@app/shared/constants';
import { UserState } from 'state-services';

const App: FC = () => {
	const navigate = useNavigate();
	const activePartnerEntity = useActivePartnerEntity();
	const { activeScope } = useAppSelector<UserState>((state) => state.user);

	const loadTabOnCapability = (): void => {
		const checkCapability = (c: UserCapabilities): boolean => activeScope.capabilities.includes(c);
		if (
			activePartnerEntity.isLighthouseEnabled &&
			checkCapability(UserCapabilities.GetLighthouseDashboard)
		) {
			navigate('/lighthouse');
		} else if (
			activePartnerEntity.isGoldCardEnabled &&
			checkCapability(UserCapabilities.GetGoldCardDashboard)
		) {
			navigate('/goldcard');
		} else {
			navigate('/admin/users');
		}
	};

	//on app load redirect to lighthouse
	useEffect(() => {
		loadTabOnCapability();
	}, []);

	return <></>;
};

export default App;
